/** Rótulos em PT para perfis do painel (coluna `users.role`). */
const ROLE_PT = {
  ADMIN: "Administrador",
  SECRETARIA: "Secretaria",
  PASTORAL: "Pastoral",
  TESOURARIA: "Tesouraria",
  USUARIO: "Utilizador",
};

export function roleLabelPt(role) {
  if (!role) return "";
  const k = String(role).toUpperCase();
  return ROLE_PT[k] || role;
}

/** Texto da barra superior: nome completo da conta + função. */
export function formatNavUserLine(user) {
  if (!user) return "";
  const name = String(user.name || "").trim() || user.email || "Utilizador";
  const r = roleLabelPt(user.role);
  return r ? `${name} · ${r}` : name;
}
